// Antd
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form } from 'antd';

// Components
import { FormSelectOption } from 'components';

// i18n
import { useTranslation } from 'react-i18next';

// Interfaces
import { IRoleMultipleSelectOptionProps } from './interfaces';

const RoleMultipleSelectOption = ({ loading, roleDropdown, form, formName }: IRoleMultipleSelectOptionProps) => {
  // Hook
  const { t } = useTranslation();

  return (
    <Form.List name={formName}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <div className="flex items-center" key={index}>
              <Form.Item noStyle shouldUpdate>
                {() => {
                  return (
                    <Form.Item
                      {...field}
                      style={{ width: '90%' }}
                      name={[field.name, 'role']}
                      fieldKey={[field.key, 'role']}
                      rules={[
                        {
                          validator: (_: any, value: { number: number }) => {
                            if (!value)
                              return Promise.reject(new Error(`${t('user.approve.form.role')} ${t('app.validations.required')}`));

                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <FormSelectOption
                        list={roleDropdown}
                        placeholder={t('user.approve.formPlaceholder.role')}
                        loading={loading}
                        disabled={loading}
                        disabledValues={form.getFieldValue('roles')?.map((role: any) => ({ label: role?.role || '' }))}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>

              <div style={{ width: '10%' }}>
                {index !== 0 && <MinusCircleOutlined className="ml-4" onClick={() => remove(field.name)} />}

                {index === 0 && fields.length !== roleDropdown.length && (
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() => {
                      if (fields.length === roleDropdown.length) {
                        return false;
                      } else {
                        add();
                      }
                    }}
                  >
                    <PlusOutlined className="ml-4 mr-2" />
                    <p className="text-grey-font font-weight-400">{t('user.approve.form.role')}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </Form.List>
  );
};

export { RoleMultipleSelectOption };
